module.exports = __webpack_public_path__ + "static/media/survive-preview.7de5e07e.wav";